'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'star-half-stroke';
var width = 576;
var height = 512;
var aliases = ["star-half-alt"];
var unicode = 'f5c0';
var svgPathData = ['M288.1 102.9l44.1 83.5 11 20.9 23.3 4 93 16.1-65.8 67.7L377.2 312l3.4 23.4L394 428.8l-84.7-41.7-21.2-10.4 0-273.8z', 'M315.2 51.4L374.6 164l125.4 21.7 57.3 9.9-40.5 41.7L428 328.5l18.1 125.9 8.3 57.6-52.2-25.7L288.1 430.2 173.9 486.3 121.7 512l8.3-57.6 18.1-125.9L59.4 237.3 18.9 195.6l57.3-9.9L201.6 164 260.9 51.4 288.1 0l27.1 51.4zm-27.1 51.4l0 273.8 21.2 10.4L394 428.8l-13.4-93.4L377.2 312l16.4-16.9 65.8-67.7-93-16.1-23.3-4-11-20.9-44.1-83.5z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;